goog.provide('el8.appchart.dialog.docTags');

goog.require('el8.app.shared.tagInputOpts');
goog.require('el8.appservice.notifier');
goog.require('el8.data.base');
goog.require('el8.template.appchart.dialog.addEditTags');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


el8.appchart.dialog.docTags = (function() {
    var doc = null;
    // callback after successfully saving doctags, will pass in an array of
    // new tag ids as the first parameter
    var successCb = null;
    // if true, we don't actually save when we submit, we just call successCb
    // useful for when using doctag dialog just to select/get a list of doctags
    var skipSave = false;
    
    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Document Tags',
        autoHeight: true,
        position: 'center',
        width: 500,
        contentFn: el8.template.appchart.dialog.addEditTags.content,
        showXButton: el8Globals.READ_ONLY
    });
    
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'docTags',
                selector: '.tags-holder',
                infoText: 'add a tag...',
                maxLength: 100,
                tagInputOpts: el8.app.shared.tagInputOpts.codedDocumentTags()
            }
        ]
    });
    form.addSaveButton(function(_form) {
        if (skipSave) {
            var newTagIds = form.getTagInput('docTags').getSelectedIds();
            if (successCb) { successCb(newTagIds); }
            that.hide();
        } else {
            submitFn();
        }
    }, true);
    form.addDiscardChangesButton(function(_form) {
        el8.appservice.notifier.notify('Tag changes discarded');
        that.hide();
    });
    that.setForm(form);

    
    var super_show = that.show;
    that.show = function(params) {
        super_show.call(that);

        doc = params['doc'] || null;
        successCb = params['successCb'] || null;
        skipSave = params.hasOwnProperty('skipSave') ? params['skipSave'] : false;

        var tagInput = form.getTagInput('docTags');
        tagInput.setTags(doc.getDocTagMaps());
        tagInput.focusField();

        that.adjustPosition();
    };

    // returns the frontend model that the doctag dialog is editing the
    // tag list for. useful for cases where we might want a parent dialog
    // to control the child doctag dialog that gets spawned
    that.getCurrentDoc = function() {
        return doc;
    };
    
    function submitFn() {
        el8.appservice.notifier.notify('Saving tags...' );
        var newTagIds = form.getTagInput('docTags').getSelectedIds();

        doc.saveDocTags(newTagIds, {
            successCb: function(data) {
                var modelClass = doc.getModelClass();

                // will let various renderers (chart, report feed), etc. know to re-render
                var entity_set = el8.ptdata.getEntitySet(modelClass);
                if (entity_set) { entity_set.trigger(EVENTS.UPDATED, doc); }

                el8.appservice.notifier.notify('Tags saved.' );
                that.hide();

                if (successCb) { successCb(newTagIds); }
            }
        });
    }
    
    return that;
    
})();

